import { Link } from 'react-router-dom';
import Routes from '../configuration/routes/RouteList';

const sectionStyle = {
  marginBottom: '28px',
};

const headingStyle = {
  fontSize: '18px',
  fontWeight: 700,
  letterSpacing: '-0.02em',
  color: 'oklch(0.97 0.004 260)',
  margin: '0 0 10px',
} as const;

const paragraphStyle = {
  margin: 0,
  fontSize: '14px',
  lineHeight: 1.7,
  color: 'oklch(0.68 0.01 260)',
} as const;

const Privacy = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'oklch(0.13 0.008 260)',
        color: 'oklch(0.97 0.004 260)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
      }}
    >
      <title>NiuMedia Privacy Policy</title>

      <div
        style={{
          maxWidth: '760px',
          margin: '0 auto',
          padding: '40px 24px 72px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: '12px',
            marginBottom: '40px',
            flexWrap: 'wrap',
          }}
        >
          <Link
            to={Routes.Landing}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              textDecoration: 'none',
            }}
          >
            <span
              style={{
                fontWeight: 800,
                fontSize: '16px',
                letterSpacing: '-0.04em',
                background:
                  'linear-gradient(135deg, oklch(0.78 0.18 260), oklch(0.65 0.22 300))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              NM
            </span>
            <span style={{ fontSize: '15px', fontWeight: 600, color: 'oklch(0.9 0.004 260)' }}>
              NiuMedia
            </span>
          </Link>

          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <Link
              to={Routes.Terms}
              style={{ color: 'oklch(0.72 0.18 265)', textDecoration: 'none', fontSize: '13px' }}
            >
              Terms of Service
            </Link>
            <Link
              to={Routes.Login}
              style={{ color: 'oklch(0.6 0.01 260)', textDecoration: 'none', fontSize: '13px' }}
            >
              Sign in
            </Link>
          </div>
        </div>

        <div
          style={{
            borderRadius: '20px',
            border: '1px solid oklch(1 0 0 / 0.1)',
            background: 'oklch(0.17 0.008 260)',
            padding: '36px 32px',
            boxShadow: '0 24px 48px oklch(0 0 0 / 0.32)',
          }}
        >
          <p
            style={{
              margin: '0 0 10px',
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: 'oklch(0.72 0.18 265)',
            }}
          >
            Legal
          </p>
          <h1
            style={{
              margin: '0 0 10px',
              fontSize: '34px',
              lineHeight: 1.1,
              letterSpacing: '-0.04em',
              color: 'oklch(0.98 0.004 260)',
            }}
          >
            Privacy Policy
          </h1>
          <p style={{ ...paragraphStyle, marginBottom: '32px' }}>
            Effective date: March 29, 2026. NiuMedia is designed to keep media processing and
            transcription under your control. This page explains what information we store, how we
            use it, and the choices you have when using our web app and related services.
          </p>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>What we collect</h2>
            <p style={paragraphStyle}>
              We may store account details such as your email address, authentication provider,
              profile name, uploaded media metadata, transcripts, notes, and task status records.
              If you sign in with a third-party provider like Google or Apple, we only receive the
              identity information that provider shares with us.
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>How we use information</h2>
            <p style={paragraphStyle}>
              We use your information to authenticate you, sync your notes and transcripts, run
              requested media-processing jobs, improve reliability, and protect the service from
              abuse. We do not sell your personal information.
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>Storage and processors</h2>
            <p style={paragraphStyle}>
              NiuMedia currently uses third-party infrastructure providers for authentication,
              database storage, and hosting. Media and transcripts may pass through processing
              services only when needed to complete a task you requested, such as transcription or
              file delivery.
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>Your controls</h2>
            <p style={paragraphStyle}>
              You can request account deletion, remove uploaded content, or stop using the service
              at any time. If a third-party identity provider is connected to your account, you can
              also revoke that connection from the provider side.
            </p>
          </section>

          <section style={sectionStyle}>
            <h2 style={headingStyle}>Security</h2>
            <p style={paragraphStyle}>
              We use reasonable technical and organizational measures to protect stored data, but no
              online system can guarantee absolute security. Please avoid uploading content that you
              do not want processed by the service.
            </p>
          </section>

          <section style={{ ...sectionStyle, marginBottom: 0 }}>
            <h2 style={headingStyle}>Contact</h2>
            <p style={paragraphStyle}>
              For privacy questions, use the contact channel provided through NiuMedia’s official
              website or product support flow. We may update this policy from time to time; material
              changes will be reflected on this page.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
